import { getDLGlobalParams } from '@js/utilities/datalayerHelpers';
import '@js/abstracts/dataLayer';

window.dataLayer.push(getDLGlobalParams());

['DOMContentLoaded', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((event) => {
    window.addEventListener(event, async (e) => {
        const { default: telInputHandler } = await import(
            /* webpackChunkName: "inputTel" */ '@js/utilities/inputTel'
        );
        const container = e.container ?? null;

        telInputHandler(container);
    });
});

// Registry for Show Keys Mode. null = mode inactive (zero overhead for regular users).
// Set to a Map() by initShowKeysMode IIFE when ?showKeys is detected.
window.__i18nRegistry = null;

window.translate = (key, obj) => {
    const t = window.__translations;
    let result;
    if (t && t[key] && obj) {
        result = Object.keys(obj).reduce((acc, k) => acc.replaceAll(`%${k}%`, obj[k]), t[key]);
    } else {
        result = (t && t[key]) || '';
    }
    // Register translation for the DOM scanner (Show Keys Mode only)
    if (window.__i18nRegistry && result) {
        window.__i18nRegistry.set(result, key);
    }
    return result;
};

/**
 * Show Keys Mode — Tryb Podglądu Kluczy i18n
 *
 * Aktywacja:   ?showKeys=true  (zapamiętane w localStorage)
 * Dezaktywacja: ?showKeys=false
 *
 * Gdy aktywny:
 *  - window.__i18nRegistry rejestruje każde tłumaczenie (tekst → klucz)
 *  - show-keys-mode.js skanuje DOM i owija znaleziony tekst w <span data-i18n-key="...">
 *  - CSS pokazuje tooltip z kluczem po najechaniu myszką
 *  - show-keys-mode.js ładuje się dynamicznie — zero kosztu dla zwykłych użytkowników
 */
(function initShowKeysMode() {
    if (!window.__showKeysAllowed) return;

    const params = new URLSearchParams(window.location.search);
    const flag = params.get('showKeys');

    if (flag === 'false' || flag === '0') {
        try {
            localStorage.removeItem('__i18n_show_keys');
        } catch (e) {
            /* noop */
        }
        // Clear PHP cookie so TranslatorExtension stops collecting on subsequent pages
        document.cookie = '__show_i18n_keys=; path=/; max-age=0; SameSite=Lax';
        return;
    }

    if (flag !== null) {
        try {
            localStorage.setItem('__i18n_show_keys', '1');
        } catch (e) {
            /* noop */
        }
    }

    let isActive = false;
    try {
        isActive = localStorage.getItem('__i18n_show_keys') === '1';
    } catch (e) {
        /* noop */
    }

    if (!isActive) return;

    // Activate registry synchronously — window.translate will start registering
    // translations immediately, even before show-keys-mode.js is loaded.
    window.__i18nRegistry = new Map();

    // Load CSS, banner and DOM scanner asynchronously — never bundled for regular users
    import(/* webpackChunkName: "show-keys-mode" */ '@js/utilities/show-keys-mode').then(
        ({ initShowKeysMode: init }) => init()
    );
})();
